import { Button } from '@/components';
import { FC, useState } from 'react';
import { FaArrowDownLong } from 'react-icons/fa6';
import DepositToWalletTray from './DepositToWalletTray';
interface Props {
  fullWidth?: boolean;
  onClick?: () => void;
}
const DepositToWalletIcon = FaArrowDownLong as React.ComponentType<any>;
const DepositToWalletButton: FC<Props> = ({
  fullWidth = false,
  onClick,
  ...props
}) => {
  const [isTrayOpen, setIsTrayOpen] = useState<boolean>(false);
  const openDepositToWalletTray = () => {
    setIsTrayOpen(true);
    if (onClick) {
      onClick();
    }
  };
  return (
    <>
      <Button
        icon={<DepositToWalletIcon className="text-accent" />}
        iconStyles={{ intent: 'accent' }}
        fullWidth={fullWidth}
        onClick={openDepositToWalletTray}
        {...props}
      >
        Deposit
      </Button>
      <DepositToWalletTray
        isOpen={isTrayOpen}
        onClose={() => setIsTrayOpen(false)}
      />
    </>
  );
};
export default DepositToWalletButton;
